// 全角→半角変換 + 数字以外除去
export const sanitizeNumberInput = (value) => {
  if (!value) return '0';
  // 全角→半角
  const halfWidth = value.toString().replace(/[０-９]/g, (s) =>
    String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
  );
  // 半角数字以外を削除
  return halfWidth.replace(/[^0-9]/g, '') || '0';
};

//税込価格
export const calculateSellingPriceIncludingTax = (sellingPrice, taxRate) => {
  const rate = taxRate ?? 0;
  return Math.floor(sellingPrice * (1 + rate / 100));
};

/*合計金額 */
// 1アイテムのサブトータルを計算
export function calculateItemSubtotal({ price = 0, quantity = 0, tax_rate = 0 }) {
  price = Number(price);
  quantity = Number(quantity);
  tax_rate = Number(tax_rate);

  const subtotal = price * quantity;
  const subtotal_including_tax =
    Math.floor(subtotal * (1 + tax_rate / 100));

  return { subtotal, subtotal_including_tax };
}

// 全アイテムの合計金額を計算
export function calculateTotalAmount(items = []) {
  const total_amount = items.reduce(
    (sum, item) => sum + (Number(item.subtotal) || 0),
    0
  );

  const total_amount_including_tax = items.reduce(
    (sum, item) => sum + (Number(item.subtotal_including_tax) || 0),
    0
  );

  return { total_amount, total_amount_including_tax };
}